/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiLongIntervalConfig} from "./UiLongIntervalConfig";
import {UiTimeChartZoomLevelConfig} from "./UiTimeChartZoomLevelConfig";
import {UiLineChartLineFormatConfig} from "./UiLineChartLineFormatConfig";
import {UiTimeGraphDataPointConfig} from "./UiTimeGraphDataPointConfig";
import {UiLineChartYScaleZoomMode} from "./UiLineChartYScaleZoomMode";
import {UiScaleType} from "./UiScaleType";
import {UiLineChartMouseScrollZoomPanMode} from "./UiLineChartMouseScrollZoomPanMode";


export interface UiTimeGraphConfig extends UiComponentConfig {
	_type?: string;
	yScaleZoomMode?: UiLineChartYScaleZoomMode;
	intervalX: UiLongIntervalConfig;
	intervalY: UiLongIntervalConfig;
	zoomLevels: UiTimeChartZoomLevelConfig[];
	maxPixelsBetweenDataPoints: number;
	lineFormats: {[name: string]: UiLineChartLineFormatConfig};
	yScaleType?: UiScaleType;
	mouseScrollZoomPanMode?: UiLineChartMouseScrollZoomPanMode
}

export interface UiTimeGraphCommandHandler {
	setIntervalX(intervalX: UiLongIntervalConfig): void;
	setIntervalY(intervalY: UiLongIntervalConfig): void;
	setMaxPixelsBetweenDataPoints(maxPixelsBetweenDataPoints: number): void;
	setYScaleType(yScaleType: UiScaleType): void;
	addData(zoomLevel: number, intervalX: UiLongIntervalConfig, data: {[name: string]: UiTimeGraphDataPointConfig[]}): void;
	resetAllData(): void;
	replaceAllData(zoomLevel: number, intervalX: UiLongIntervalConfig, data: {[name: string]: UiTimeGraphDataPointConfig[]}): void;
	setYScaleZoomMode(yScaleZoomMode: UiLineChartYScaleZoomMode): void;
	setMouseScrollZoomPanMode(mouseScrollZoomPanMode: UiLineChartMouseScrollZoomPanMode): void;
	setSelectedInterval(intervalX: UiLongIntervalConfig): void;
	setLineFormats(lineFormats: {[name: string]: UiLineChartLineFormatConfig}): void;
}

export interface UiTimeGraphEventSource {
	onDataNeeded: TeamAppsEvent<UiTimeGraph_DataNeededEvent>;
	onZoomed: TeamAppsEvent<UiTimeGraph_ZoomedEvent>;
	onIntervalSelected: TeamAppsEvent<UiTimeGraph_IntervalSelectedEvent>;
}

export interface UiTimeGraph_DataNeededEvent extends UiEvent {
	_type: "UiTimeGraph.dataNeeded";
	redundancyKey?: string;
	zoomLevelIndex: number;
	neededIntervalX: UiLongIntervalConfig
}

export interface UiTimeGraph_ZoomedEvent extends UiEvent {
	_type: "UiTimeGraph.zoomed";
	redundancyKey?: string;
	intervalX: UiLongIntervalConfig;
	zoomLevelIndex: number
}

export interface UiTimeGraph_IntervalSelectedEvent extends UiEvent {
	_type: "UiTimeGraph.intervalSelected";
	redundancyKey?: string;
	intervalX: UiLongIntervalConfig
}

